<div class="navigator" *ngIf="hasRenewalStrategy">
    <span (click)="navigateToPlatform()"  appTooltip title="Generate Report PDF"  data-size="big"  [options]="tooltipOptions">
        <a type="submit" class="c-button primary-color-bg detail-colors" [ngClass]="{'navigator-disabled': !navigatorEnabled}">
            <i class="fa fa-clone" aria-hidden="true"></i>
        </a>
    </span>
</div>